<div class="header-banner bg-black" *ngIf="showPromotion">
  <div
    class="mx-auto flex items-center justify-end p-1 px-3 md:container md:px-1">
    <!-- <div class="language flex-1 text-gray-500">
      <div class="relative w-fit">
        <button
          type="button"
          class="flex items-center gap-3 rounded-md py-1 px-4 text-sm hover:bg-white/30 md:w-[150px]"
          (click)="dropdownLang.toggle($event)">
          <fa-icon [icon]="faGlobe"></fa-icon>
          <span class="hidden md:block">{{ countries[0].name }}</span>
          <fa-icon [icon]="faChevronDown"></fa-icon>
        </button>
        <fc-dropdown #dropdownLang fcStyleClass="fc-dropdown left-0">
          <div
            class="grid divide-y divide-primary-main rounded-md border-t bg-white shadow-xl">
            <button
              type="button"
              class="flex w-[150px] items-center gap-3 rounded-md py-1 px-4 text-sm text-primary-darkest hover:bg-black/5"
              *ngFor="let country of countries"
              (click)="dropdownLang.toggle($event)">
              <img class="h-4 w-4" [src]="country.imgPath" alt="" srcset="" />
              <span>{{ country.name }}</span>
            </button>
          </div>
        </fc-dropdown>
      </div>
    </div>
    <div class="promotion text-center text-gray-500">
      <p class="text-sm">10% Discount For All New Customer</p>
    </div> -->
    <div class="merchant flex-1 text-white/80">
      <a
        class="flex items-center justify-end gap-3 text-sm"
        href="https://merchant.happybeauty.com.sg"
        target="_blank">
        <fa-icon [icon]="faStore"></fa-icon>
        <p>Sell on Happybeauty</p>
      </a>
    </div>
  </div>
</div>
<header
  class="sticky top-0 z-40 border-b border-gray-50 bg-white shadow-md shadow-gray-400/10">
  <div class="header-nav__desktop hidden md:block">
    <div class="container mx-auto flex items-center justify-between gap-5 py-3">
      <div class="logo flex-none">
        <a routerLink="/">
          <img
            class="h-10"
            src="/assets/images/logo-hb-sm.webp"
            alt="happybeautylogo" />
        </a>
      </div>
      <div class="relative flex-1">
        <div class="p-input-icon-right w-full">
          <input
            pInputText
            type="text"
            class="w-full rounded-full py-[7px] px-4"
            placeholder="Search on Happybeauty"
            fcDebounceKeyup
            [debounceTime]="900"
            [(ngModel)]="searchQuery"
            (onEvent)="search.search()"
            (click)="dropdownSearch.show($event)" />
          <i class="pi pi-search"></i>
        </div>
        <fc-dropdown
          #dropdownSearch
          fcStyleClass="fc-dropdown fc-dropdown-center w-full mx-auto">
          <div
            class="h-[400px] overflow-y-auto rounded-md bg-white p-4 shadow-lg">
            <fc-search #search [searchQuery]="searchQuery"></fc-search>
          </div>
        </fc-dropdown>
      </div>
      <div class="authorized-action flex items-center gap-3" *ngIf="user">
        <fc-notification-dropdown
          #notificationDropdown></fc-notification-dropdown>
        <fc-cart-dropdown [cart]="cart" #cartDropdown></fc-cart-dropdown>
        <fc-user-dropdown></fc-user-dropdown>
      </div>
      <div class="unauthorized-action flex gap-3" *ngIf="!user">
        <button
          type="button"
          routerLink="/auth/login"
          class="primary-dark rounded-full border-2 border-primary-dark py-2 px-6 text-sm font-medium text-primary-darkest hover:bg-primary-dark">
          <fa-icon [icon]="faUser" class="mr-2"></fa-icon>
          <span> Login </span>
        </button>
      </div>
    </div>
    <hr class="border-primary-dark/40" />
    <nav class="container mx-auto">
      <ul
        class="flex items-center justify-center gap-5 py-1 text-sm text-primary-darkest">
        <li>
          <a
            class="cursor-pointer rounded-md py-1 px-3 hover:bg-primary-light"
            routerLink="/">
            Home
          </a>
        </li>
        <li>
          <button
            class="cursor-pointer rounded-md py-1 px-3 hover:bg-primary-light"
            type="button"
            [ngClass]="
              dropdownCategory.dropdownOpened ? 'bg-primary-light' : ''
            "
            (click)="dropdownCategory.toggle($event)">
            Category
          </button>
          <fc-dropdown
            #dropdownCategory
            fcStyleClass="fc-dropdown fc-dropdown-center container mx-auto">
            <fc-category-dropdown></fc-category-dropdown>
          </fc-dropdown>
        </li>
        <li>
          <button
            class="cursor-pointer rounded-md py-1 px-3 hover:bg-primary-light"
            type="button"
            [ngClass]="dropdownBrand.dropdownOpened ? 'bg-primary-light' : ''"
            (click)="dropdownBrand.toggle($event)">
            Brand
          </button>
          <fc-dropdown
            #dropdownBrand
            fcStyleClass="fc-dropdown fc-dropdown-center container mx-auto">
            <fc-brand-dropdown></fc-brand-dropdown>
          </fc-dropdown>
        </li>
        <li>
          <a
            [routerLink]="['/product']"
            [queryParams]="{ sale: true }"
            class="relative cursor-pointer rounded-md py-1 px-3 font-bold hover:bg-primary-light">
            Sale
            <span
              class="absolute top-1 right-1 h-1 w-1 rounded-full bg-red-500"></span>
          </a>
        </li>
        <li>
          <a
            class="cursor-pointer rounded-md py-1 px-3 hover:bg-primary-light"
            routerLink="/beautybook/list">
            Beauty Book
          </a>
        </li>
        <li>
          <a
            class="cursor-pointer rounded-md py-1 px-3 hover:bg-primary-light"
            [routerLink]="['/user/dashboard']">
            Skin Fit
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div class="header-nav__mobile md:hidden">
    <div class="mx-auto flex items-center justify-between gap-3 py-3 px-3">
      <div class="back" *ngIf="mobileLayoutConfig.headerNav.backButton">
        <button
          type="button"
          class="flex items-center gap-2 text-gray-500"
          (click)="back()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>
      </div>
      <div
        class="title flex-1 text-xl font-medium text-primary-darkest"
        *ngIf="mobileLayoutConfig.headerNav.title">
        {{ mobileLayoutConfig.headerNav.title }}
      </div>
      <div
        class="search p-input-icon-right flex-1"
        *ngIf="mobileLayoutConfig.headerNav.searchButton">
        <input
          (click)="toggleMobileSearch()"
          pInputText
          type="text"
          class="w-full rounded-full py-[7px] px-4"
          placeholder="Search on Happybeauty"
          fcDebounceKeyup
          [(ngModel)]="searchQuery" />
        <i class="pi pi-search"></i>
        <div
          class="fixed top-0 left-0 z-50 h-screen w-full bg-white"
          [ngClass]="
            isMobileSearchShowed ? 'translate-y-0' : 'translate-y-[100vh]'
          ">
          <div class="header flex items-center p-3">
            <button class="p-3" (click)="toggleMobileSearch()">
              <fa-icon
                [icon]="faArrowLeft"
                class="text-2xl text-gray-500"></fa-icon>
            </button>
            <div class="flex-1">
              <div class="p-input-icon-right w-full">
                <input
                  #mobileSearchInput
                  pInputText
                  type="text"
                  class="w-full rounded-full py-[7px] px-4"
                  placeholder="Search on Happybeauty"
                  fcDebounceKeyup
                  [debounceTime]="900"
                  [(ngModel)]="searchQuery"
                  (onEvent)="mobileSearch.search()" />
                <i class="pi pi-search"></i>
              </div>
            </div>
          </div>
          <div class="body h-full overflow-y-auto px-3 pb-[100px]">
            <fc-search
              #mobileSearch
              [searchQuery]="searchQuery"
              (click)="toggleMobileSearch()"></fc-search>
          </div>
        </div>
      </div>
      <div class="main-menu flex gap-3">
        <div
          class="notification"
          *ngIf="mobileLayoutConfig.headerNav.notificationButton">
          <button type="button" class="p-2" routerLink="/notification">
            <fa-icon class="text-gray-500" [icon]="faBell"></fa-icon>
          </button>
        </div>
        <div class="cart" *ngIf="mobileLayoutConfig.headerNav.cartButton">
          <button
            type="button"
            class="relative rounded-md p-2"
            routerLink="/cart">
            <fa-icon class="text-gray-500" [icon]="faCartShopping"></fa-icon>
            <span
              class="absolute -top-1 -right-1 rounded-full bg-red-500 py-[2px] px-[6px] text-xs font-medium text-white"
              *ngIf="cart.totalCartItems"
              >{{ cart.totalCartItems }}</span
            >
          </button>
        </div>
        <fc-mobile-menu
          [user]="user"
          *ngIf="mobileLayoutConfig.headerNav.userButton"></fc-mobile-menu>
      </div>
    </div>
  </div>
</header>
